import { useTranslations } from '@vocab/react';
import { Button, IconAI } from 'braid-design-system';

import { useSignedInDashboardContext } from '../../SignedInDashboardContextProvider';
import { CareerFeedAiAssistantInitialState } from '../CareerFeedAiAssistantInitialState/CareerFeedAiAssistantInitialState';
import { CareerFeedAssistantQuestions } from '../CareerFeedAssistantQuestions/CareerFeedAssistantQuestions';
import { useGetRefreshRecommendationsWithCandidateChatContext } from '../hooks/candidateChatContextHelpers';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

import translations from './.vocab';
import { CareerFeedAIAssistantContentFrame } from './CareerFeedAIAssistantContentFrame';

const ConversationFinished = () => {
  const { t } = useTranslations(translations);

  const { lastCompletedAssistantResponse } = useCareerFeedAIAssistant();
  const {
    recommendationsResult: { isRefreshLoading },
  } = useSignedInDashboardContext();

  const refreshRecommendations =
    useGetRefreshRecommendationsWithCandidateChatContext();

  return (
    <CareerFeedAIAssistantContentFrame
      headMessage={lastCompletedAssistantResponse!.text}
      ctaSection={
        <Button
          tone="brandAccent"
          icon={<IconAI />}
          onClick={refreshRecommendations}
          loading={isRefreshLoading}
        >
          {t('Refresh recommendations')}
        </Button>
      }
    />
  );
};

export const CareerFeedAIAssistantContent = () => {
  const { sessionId, conversationFinished } = useCareerFeedAIAssistant();

  if (!sessionId) {
    return <CareerFeedAiAssistantInitialState />;
  }

  if (conversationFinished) {
    return <ConversationFinished />;
  }

  return <CareerFeedAssistantQuestions />;
};
